import { Button } from '@optools/components/ui/button';
import { selectToolsConfig } from '@optools/store/configApiSlice';
import { useAppSelector } from '@optools/store/hooks';

import { generateDatadogLink } from '../utils/link';

export interface ExternalLogsProps {
  userId: string;
}

export function ExternalLogs({ userId }: ExternalLogsProps) {
  const {
    userLookup: {
      baseConvivaLink,
      dataDogLink: { baseurl, staticParams },
    },
  } = useAppSelector(selectToolsConfig);
  const dataDogLink = generateDatadogLink(baseurl, userId, staticParams);

  return (
    <div className="flex flex-col space-y-4 p-1">
      <h2 className="text-sm font-bold">External Logs</h2>
      <div className="flex space-x-2">
        <Button asChild>
          <a href={`${baseConvivaLink}${userId}`} rel="noreferrer" target="_blank">
            Conviva Sessions
          </a>
        </Button>
        <Button asChild>
          <a href={dataDogLink} rel="noreferrer" target="_blank">
            DataDog Logs
          </a>
        </Button>
      </div>
    </div>
  );
}
